export const businessType = {
  A: 'Large Business/Other Business',
  B: 'Small Business',
  C: 'Nonprofit Institution',
  E: 'Educational Institution (other than HBCU or Minority)',
  F: 'Historically Black College or University (HBCU)',
  G: 'JWOD Participating Nonprofit Agency',
  M: 'Small Disadvantaged Business',
  P: 'Minority Institution (other than HBCU)',
  X: 'Intragovernmental',
};

export const disadvantagedBusiness = {
  A: 'Asian-Indian American',
  B: 'Asian-Pacific American',
  C: 'Black American',
  D: 'Hispanic American',
  E: 'Native American',
  F: 'Other SDB Certified or Determined by SBA',
};

export const womanOwned = {
  W: 'Woman Owned Small Business',
  E: 'Economically Disadvantaged Woman Owned Small Business',
  N: 'No',
};

export const vetranOwned = {
  R: 'Service Disabled Veteran-Owned Small Business',
  T: 'Other Veteran-Owned Small Business',
};

export const hubZone = {
  Y: 'Yes',
  N: 'No',
};

export const jointVenture = {
  JV: 'Is a Joint Venture that complies with 13 CFR Part 126',
  JN: 'Is not a Joint Venture that complies with 13 CFR Part 126',
};

export const affirmativeActionCompliance = {
  Y6: 'Developed and on File',
  N6: 'Not Developed and Not on File',
  NH: 'No Previous Contracts Subject to Requirements',
  NA: 'Not Applicable',
};

export const previousContract = {
  Y4: 'Participated and Filed',
  Y5: 'Participated and Not Filed',
  N4: 'Not Participated',
  NA: 'Not Applicable',
};

export const disputesRes = {
  A: 'Agree To Use Alternate Disputes Resolution',
  B: 'Do Not Agree To Use Alternate Disputes Resolution',
};



// WEBPACK FOOTER //
// ./src/pages/DibbsRfq/optionsJson/company.js